$(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-toimiala-varhaiskasvatus-ja-koulutus/"
    };

    $("#childhoodForm").on("submit", function(event) {
        event.preventDefault();
        if ($('#childhoodForm')[0].checkValidity()) {
            $("#childhoodFormSendBtn").prop("disabled", true);
            $("#childhoodFormSendBtn").css("background-color", "#6c757d");
            let email = $("#childhoodFormEmail").val();
            let firstName = $("#childhoodFormFirstName").val();
            let lastName = $("#childhoodFormLastName").val();
            let phone = $("#childhoodFormPhoneNumber").val();
            let message = $("#childhoodFormMessage").val();
            let organization = $("#childhoodFormOrganization").val();
            let code = "";
           /*  if ($('#languageServicesNewsLetterCheckbox').is(':checked')) {
                code = "newsletter";
            } */
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phone,
                organizationName: organization,
                competitionName: "Varhaiskasvatus",
                uri: "/fi/varhaiskasvatus-ja-koulutus/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#childhoodFormSendBtn").prop("disabled", false);
                    $("#childhoodFormSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#childhoodForm')[0].checkValidity();

        if (formValid) {
            // Enable button and change color
            $("#childhoodFormSendBtn").prop("disabled", false);
            $("#childhoodFormSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#childhoodFormSendBtn").prop("disabled", true);
            $("#childhoodFormSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#childhoodForm input').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});
